/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { classNames } from '../utils/UNSAFE_classNames';
import { messageSummaryStyles } from './themes/MessageStyles.css';
import { MessageVariant } from './Message.types';

/**
 * Props for the Summary component
 */
type Props = {
  /**
   * The summary text
   */
  text?: string;

  /**
   * Style variant
   */
  variant?: MessageVariant;
};

/**
 * Summary Component for rendering the summary text of the Message
 */
function MessageSummary({ text, variant = 'banner' }: Props) {
  // If detail content is rendered, then wrap it in a div with specified style classes
  // TODO: JET-48715 - remove marker classes
  // Right now, oj-message-banner component uses this for unit tests and has no alternate way for
  // testing. This will need to be removed as we work on oj-c-message-banner.
  // TODO:  Refactor to utilize useComponentTheme and multiVariantStyles.

  const markerClassForTests = 'oj-c-messagebanner-summary';
  const classes = classNames([
    variant === 'banner' && markerClassForTests,
    messageSummaryStyles.base,
    messageSummaryStyles[variant]
  ]);
  return (
    <div role="heading" class={classes}>
      {text}
    </div>
  );
}

export { MessageSummary };
